import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import {
    clssInfo,
    FinalConcepts,
    indexGrades,
    GetGradeFinalConcepts,
    GetMatter,
    GetMatterDetails,
    FinalConceptsEdit,
    DestroyFinalGrade
} from '../../Api'

import {
    Container,
    ContainerDivs,
    List,
    ListChecked,
    Emp,
    Span,
    Btt01,
    Btt02,
    Grade,
    ContainerStudent,
    EditContainer,
    ErrorMessage,
    DataSelected,
    Select,
    InputArea,
    Input,
    ToGoBack,
    SignMessageButtonText,
    SignMessageButtonTextBold,
    Label,
    LegendBox,
    Info,
    DivBimTable,
    DivBimRow,
    DivBimHeader,
    DivBimCell,
    BoxButton,
    EmpEdit,
    BlurBackground,
    ModalContainer,
    AreaWrapper,
    Area,
    ContSelect,
    ContConcept
} from './style'

import LoadingSpinner from '../../components/Loading'
import { SlActionUndo } from "react-icons/sl"

// ── helpers fora do componente ──────────────────────────────────────
// Compara ids que podem vir como string crua, string JSON ou objeto.
const sameId = (a, b) => {
    const norm = (v) => {
        if (v == null) return ''
        if (typeof v === 'string') {
            const t = v.trim()
            if (t.startsWith('"') || t.startsWith('{') || t.startsWith('[')) {
                try { v = JSON.parse(t) } catch { return t }
            } else {
                return t
            }
        }
        if (Array.isArray(v)) v = v[0]
        if (v && typeof v === 'object') return String(v._id ?? v.id ?? '')
        return String(v ?? '')
    }
    const na = norm(a), nb = norm(b)
    return !!na && na === nb
}

const safeParse = (raw) => {
    try { return raw ? JSON.parse(raw) : null } catch { return raw }
}

// conceito de um aluno em um bimestre específico (para a tabela de referência)
const bimGrade = (quarterArr, studentId) =>
    quarterArr.find(q => q?.id_student?._id === studentId)?.studentGrade || 'N/A'

const Finalconcepts = () => {

    const navigate = useNavigate()
    const location = useLocation()
    // funcionário (professor) escolhido pelo supervisor na tela anterior
    const { employee } = location.state || {}

    // ── status do último período (aberto/fechado) ────────────────────
    const [open, setOpen] = useState('aberto')

    // ── contexto ─────────────────────────────────────────────────────
    const [Namematter, setNameMatter] = useState('')
    const [year, setYear] = useState('')
    const [id_matter, setSelectMatter] = useState('')
    const [matter, setMatter] = useState([])
    const [id_class, setId_class] = useState('')
    const [id_teacher, setId_teacher] = useState('')
    const [assessmentRegime, setAssessmentRegime] = useState('')

    // ── papéis de professor ──────────────────────────────────────────
    const [RegentTeacher, setclassRegentTeacher] = useState(null)
    const [RegentTeacher02, setclassRegentTeacher02] = useState(null)
    const [physicalEducation, setphysicalEducationTeacher] = useState(null)

    // ── listas ───────────────────────────────────────────────────────
    const [stdt, setStdt] = useState([])          // alunos sem conceito final (a lançar)
    const [checked, setChecked] = useState([])     // conceitos finais já lançados

    // ── conceitos por bimestre (tabela de referência) ────────────────
    const [iStQuarter, setiStQuarter] = useState([])
    const [iiNdQuarter, setiiNdQuarter] = useState([])
    const [iiiRdQuarter, setIIIrdQuarter] = useState([])
    const [ivThQuarter, setIVthQuarter] = useState([])

    // ── edição inline ────────────────────────────────────────────────
    const [namestudent, setNamestudent] = useState(null)
    const [update_id_grade, setUpdateIdGrade] = useState(null)
    const [update_studentGrade, setUpdateStudentGrade] = useState('')
    const [savingEdit, setSavingEdit] = useState(false)

    // ── exclusão ─────────────────────────────────────────────────────
    const [confirmModal, setConfirmModal] = useState(false)
    const [selectedGrade, setSelectedGrade] = useState(null)
    const [deleting, setDeleting] = useState(false)

    // ── UI ───────────────────────────────────────────────────────────
    const [loading, setLoading] = useState(true)
    const [loadError, setLoadError] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [warning, setWarning] = useState('')
    const [finalizing, setFinalizing] = useState(false)

    // troca de disciplina
    const [selectedMatter, setSelectedMatter] = useState('')
    const [definingMatter, setDefiningMatter] = useState(false)
    const [showMatterUpdated, setShowMatterUpdated] = useState(false)

    const mountedRef = useRef(true)
    const [reloadKey, setReloadKey] = useState(0)

    //const isFinalOpen = open === 'aberto'
    const periodLabel = assessmentRegime === 'TRIMESTRAL' ? 'TRIM' : 'BIM'

    // ── monta listas (a lançar / lançados) — DRY ─────────────────────
    const buildLists = useCallback((resGrade, resClass) => {
        const realized = (resGrade?.data?.data || [])
        const realizedIds = realized.map(r => r?.id_student?._id).filter(Boolean)
        const turma = (resClass?.data?.data || []).find(Boolean)
        const allStudents = turma?.id_student || []
        const pending = allStudents
            .filter(s => s && !realizedIds.includes(s._id))
            .map(s => ({ ...s, concept: '' }))
        return { pending, realized }
    }, [])

    // ── CARGA PRINCIPAL ──────────────────────────────────────────────
    useEffect(() => {
        mountedRef.current = true
        let cancelled = false
        const safeSet = (fn) => { if (!cancelled && mountedRef.current) fn() }

        ;(async () => {
            safeSet(() => { setLoading(true); setLoadError('') })

            const idSchool = safeParse(sessionStorage.getItem('id-school'))
            // supervisor: o funcionário vem do state da navegação (não do localStorage)
            const teacherId = employee
            const classId = sessionStorage.getItem('class-info')
            const regime = sessionStorage.getItem('assessmentRegime') || ''
            // matéria já vem da página de conceitos finais (Selectmatter)
            const selectedMatt = sessionStorage.getItem('Selectmatter')

            const regent = safeParse(sessionStorage.getItem('classRegentTeacher'))
            const regent02 = safeParse(sessionStorage.getItem('classRegentTeacher02'))
            const physical = safeParse(sessionStorage.getItem('physicalEducationTeacher'))

            // contexto que não depende de rede
            safeSet(() => {
                setAssessmentRegime(regime)
                setclassRegentTeacher(regent)
                setclassRegentTeacher02(regent02)
                setphysicalEducationTeacher(physical)
                setId_teacher(teacherId)
                setId_class(classId || '')
                setSelectMatter(selectedMatt || '')
            })

            if (!classId) {
                safeSet(() => {
                    setLoadError('Não foi possível carregar os dados da turma. Volte e selecione a turma novamente.')
                    setLoading(false)
                })
                return
            }

            try {
                const amIPhysical = sameId(teacherId, physical)

                // turma + matérias da escola, em paralelo
                const [resClass, resMatter] = await Promise.all([
                    clssInfo(classId),
                    GetMatter(idSchool)
                ])
                if (cancelled || !mountedRef.current) return

                const turma = (resClass?.data?.data || []).find(Boolean)
                const yearValue = turma?.year

                // status do último período (trim=3º / bim=4º) por tipo de professor
                const periodoFinal = regime === 'TRIMESTRAL' ? '3º BIMESTRE' : '4º BIMESTRE'
                const st = turma?.dailyStatus?.[periodoFinal]
                if (st) {
                    safeSet(() => setOpen(amIPhysical ? st.physicalEducationTeacher : st.regentTeacher))
                }

                // matérias filtradas por tipo de professor
                const allMatters = resMatter?.data?.data || []
                const filteredMatters = allMatters.filter(m =>
                    amIPhysical ? m.name === 'EDUCAÇÃO FÍSICA' : m.name !== 'EDUCAÇÃO FÍSICA'
                )
                safeSet(() => {
                    setMatter(filteredMatters)
                    setYear(yearValue || '')
                })

                // se há matéria selecionada, carrega tudo dela em paralelo:
                // conceitos por bimestre (tabela) + conceitos finais + nome da matéria
                if (selectedMatt && yearValue) {
                    const [grades, resGrade, Matter] = await Promise.all([
                        indexGrades(yearValue, classId, selectedMatt),
                        GetGradeFinalConcepts(yearValue, selectedMatt),
                        GetMatterDetails(selectedMatt)
                    ])
                    if (cancelled || !mountedRef.current) return

                    const all = grades?.data?.data || []
                    safeSet(() => {
                        setiStQuarter(all.filter(r => r.bimonthly === '1º BIMESTRE'))
                        setiiNdQuarter(all.filter(r => r.bimonthly === '2º BIMESTRE'))
                        setIIIrdQuarter(all.filter(r => r.bimonthly === '3º BIMESTRE'))
                        setIVthQuarter(all.filter(r => r.bimonthly === '4º BIMESTRE'))
                    })

                    const { pending, realized } = buildLists(resGrade, resClass)
                    safeSet(() => {
                        setStdt(pending)
                        setChecked(realized)
                        setNameMatter(Matter?.data?.name || '')
                    })
                }

                safeSet(() => { setLoading(false); setLoadError('') })
            } catch (err) {
                console.error('Erro ao carregar a grade final:', err)
                safeSet(() => {
                    setLoadError('Erro ao carregar os dados. Verifique sua conexão e tente novamente.')
                    setLoading(false)
                })
            }
        })()

        return () => { cancelled = true; mountedRef.current = false }
    }, [reloadKey, employee, buildLists])

    // aviso "disciplina alterada"
    useEffect(() => {
        const changed = sessionStorage.getItem('matterChanged')
        if (changed === 'true') {
            setShowMatterUpdated(true)
            sessionStorage.removeItem('matterChanged')
            const t = setTimeout(() => setShowMatterUpdated(false), 6000)
            return () => clearTimeout(t)
        }
    }, [])

    // limpa aviso não-bloqueante após alguns segundos
    useEffect(() => {
        if (!warning) return
        const t = setTimeout(() => setWarning(''), 6000)
        return () => clearTimeout(t)
    }, [warning])

    // recarrega conceitos finais (lançados / a lançar) sem reload de página
    const refreshGradesAndStudents = useCallback(async () => {
        try {
            const [resGrade, resClass] = await Promise.all([
                GetGradeFinalConcepts(year, id_matter),
                clssInfo(id_class)
            ])
            if (!mountedRef.current) return
            const { pending, realized } = buildLists(resGrade, resClass)
            setStdt(pending)
            setChecked(realized)
            setErrorMessage('')
        } catch (err) {
            console.error(err)
            if (mountedRef.current) setErrorMessage('Erro ao atualizar as listas.')
        }
    }, [year, id_matter, id_class, buildLists])

    // atualiza conceito local de um aluno (não envia)
    const handleConceptChange = (studentId, value) => {
        setStdt(prev => prev.map(s => s._id === studentId ? { ...s, concept: value } : s))
        setErrorMessage('')
    }

    // resolve teacher01/teacher02 conforme o papel
    const resolveTeachers = () => {
        let teacher01 = id_teacher
        let teacher02 = null
        if (sameId(RegentTeacher, id_teacher)) {
            teacher02 = RegentTeacher02
        } else if (sameId(RegentTeacher02, id_teacher)) {
            teacher02 = RegentTeacher02
            teacher01 = RegentTeacher
        } else if (sameId(physicalEducation, id_teacher)) {
            teacher02 = null
        }
        return { teacher01, teacher02 }
    }

    // ── envia todos os conceitos finais preenchidos (otimista) ───────
    const handleFinalize = async () => {
        if (finalizing) return

        const toSend = stdt.filter(s => s.concept && s.concept.trim() !== '')

        if (toSend.length === 0) {
            setErrorMessage('Preencha ao menos um conceito antes de finalizar.')
            return
        }

        const semConceito = stdt.length - toSend.length
        if (semConceito > 0) {
            const msg = `Atenção: ${semConceito} aluno(s) sem conceito definido não serão enviados.`
            setWarning(msg)
            alert(msg) // visível mesmo com a página rolada
        }

        setFinalizing(true)
        setErrorMessage('')

        const prevStdt = stdt
        const prevChecked = checked
        const { teacher01, teacher02 } = resolveTeachers()

        // atualização otimista: tira de "a lançar" e mostra em "lançados"
        const optimisticChecked = toSend.map(s => ({
            _id: `temp-${s._id}`,
            studentGrade: s.concept,
            id_student: { _id: s._id, name: s.name }
        }))
        setStdt(prev => prev.filter(s => !s.concept || s.concept.trim() === ''))
        setChecked(prev => [...prev, ...optimisticChecked])

        try {
            const promises = toSend.map(s =>
                FinalConcepts(year, s.concept, id_matter, teacher01, teacher02, s._id, id_class)
            )
            await Promise.all(promises)
            if (!mountedRef.current) return
            refreshGradesAndStudents()
        } catch (err) {
            console.error(err)
            if (mountedRef.current) {
                setStdt(prevStdt)
                setChecked(prevChecked)
                setErrorMessage('Erro ao enviar conceitos. Nada foi salvo, tente novamente.')
            }
        } finally {
            if (mountedRef.current) setFinalizing(false)
        }
    }

    // ── edição (otimista) ────────────────────────────────────────────
    const startEditing = (grade) => {
        setUpdateStudentGrade(grade.studentGrade ?? '')
        setUpdateIdGrade(grade._id)
        setNamestudent(grade)
        setErrorMessage('')
    }

    const cancelEditing = () => {
        if (savingEdit) return
        setUpdateIdGrade(null)
        setNamestudent(null)
        setUpdateStudentGrade('')
    }

    const saveEdit = async () => {
        if (savingEdit) return
        if (!update_studentGrade) {
            setErrorMessage('Selecione um conceito ou marque "Não adicionar nota".')
            return
        }

        const editedId = update_id_grade
        const novo = update_studentGrade
        const prevChecked = checked

        // otimista: aplica e fecha edição
        setChecked(prev => prev.map(c =>
            c._id === editedId ? { ...c, studentGrade: novo } : c
        ))
        setUpdateIdGrade(null)
        setNamestudent(null)
        setUpdateStudentGrade('')
        setSavingEdit(true)
        setErrorMessage('')

        try {
            await FinalConceptsEdit(editedId, novo)
            if (!mountedRef.current) return
            refreshGradesAndStudents()
        } catch (err) {
            console.error(err)
            if (mountedRef.current) {
                setChecked(prevChecked)
                setErrorMessage('Erro ao salvar a alteração. O conceito foi mantido como estava.')
            }
        } finally {
            if (mountedRef.current) setSavingEdit(false)
        }
    }

    const Return = () => navigate(-1)
    const Finalyze = () => navigate(-1)

    // ── exclusão (otimista) ──────────────────────────────────────────
    const handleDeleteClick = (grade) => {
        setSelectedGrade(grade)
        setConfirmModal(true)
    }

    const handleConfirm = async () => {
        if (!selectedGrade || deleting) return

        const removed = selectedGrade
        const prevChecked = checked

        // atualização otimista: remove da tela na hora
        setChecked(prev => prev.filter(c => c._id !== removed._id))
        setConfirmModal(false)
        setSelectedGrade(null)
        setDeleting(true)

        try {
            await DestroyFinalGrade(removed._id)
            if (!mountedRef.current) return

            // Sucesso = não lançou exceção (mesmo critério de edição/finalizar).
            // O axios lança sozinho em status de erro (4xx/5xx).
            // Ressincroniza, mas SEM deixar o servidor "atrasado" readicionar
            // o item recém-removido (guarda anti-eco).
            try {
                const [resGrade, resClass] = await Promise.all([
                    GetGradeFinalConcepts(year, id_matter),
                    clssInfo(id_class)
                ])
                if (!mountedRef.current) return
                const { realized } = buildLists(resGrade, resClass)
                const realizedSafe = realized.filter(c => c._id !== removed._id)
                const realizedIds = realizedSafe.map(c => c?.id_student?._id).filter(Boolean)
                const turma = (resClass?.data?.data || []).find(Boolean)
                const allStudents = turma?.id_student || []
                const pendingSafe = allStudents
                    .filter(s => s && !realizedIds.includes(s._id))
                    .map(s => ({ ...s, concept: '' }))
                setChecked(realizedSafe)
                setStdt(pendingSafe)
                setErrorMessage('')
            } catch {
                // se a ressincronização falhar, mantém o estado otimista (já correto)
            }
        } catch (err) {
            console.error(err)
            if (mountedRef.current) {
                setChecked(prevChecked)
                setErrorMessage('Erro ao deletar o conceito. Nada foi excluído, tente novamente.')
            }
        } finally {
            if (mountedRef.current) setDeleting(false)
        }
    }

    const handleCancel = () => {
        if (deleting) return
        setConfirmModal(false)
        setSelectedGrade(null)
    }

    // ── trocar disciplina (sem reload) ───────────────────────────────
    const handleDefineMatter = async () => {
        if (definingMatter) return
        if (!selectedMatter) {
            setWarning('Selecione uma matéria.')
            return
        }
        setDefiningMatter(true)
        setErrorMessage('')
        try {
            const Matter = await GetMatterDetails(selectedMatter)
            const nameMatter = Matter?.data?.name || ''

            sessionStorage.setItem('Selectmatter', selectedMatter)
            sessionStorage.setItem('nameMatter', nameMatter)

            if (!mountedRef.current) return
            setSelectMatter(selectedMatter)
            setNameMatter(nameMatter)
            setSelectedMatter('')
            setShowMatterUpdated(true)
            setTimeout(() => mountedRef.current && setShowMatterUpdated(false), 6000)
            setReloadKey(k => k + 1) // recarrega os dados da nova disciplina
        } catch (err) {
            console.error(err)
            if (mountedRef.current) setErrorMessage('Erro ao trocar a disciplina. Tente novamente.')
        } finally {
            if (mountedRef.current) setDefiningMatter(false)
        }
    }

    // tabela de conceitos por bimestre (referência) para um aluno
    const renderBimTable = (studentId, withFinal = null) => (
        <DivBimTable>
            <DivBimRow>
                <DivBimHeader>1º {periodLabel}</DivBimHeader>
                <DivBimCell grade={bimGrade(iStQuarter, studentId)}>{bimGrade(iStQuarter, studentId)}</DivBimCell>
            </DivBimRow>
            <DivBimRow>
                <DivBimHeader>2º {periodLabel}</DivBimHeader>
                <DivBimCell grade={bimGrade(iiNdQuarter, studentId)}>{bimGrade(iiNdQuarter, studentId)}</DivBimCell>
            </DivBimRow>
            <DivBimRow>
                <DivBimHeader>3º {periodLabel}</DivBimHeader>
                <DivBimCell grade={bimGrade(iiiRdQuarter, studentId)}>{bimGrade(iiiRdQuarter, studentId)}</DivBimCell>
            </DivBimRow>
            {assessmentRegime !== 'TRIMESTRAL' && (
                <DivBimRow>
                    <DivBimHeader>4º {periodLabel}</DivBimHeader>
                    <DivBimCell grade={bimGrade(ivThQuarter, studentId)}>{bimGrade(ivThQuarter, studentId)}</DivBimCell>
                </DivBimRow>
            )}
            {withFinal != null && (
                <DivBimRow>
                    <DivBimHeader>Final</DivBimHeader>
                    <DivBimCell grade={withFinal}>{withFinal}</DivBimCell>
                </DivBimRow>
            )}
        </DivBimTable>
    )

    // ── RENDER ───────────────────────────────────────────────────────
    if (loading) {
        return (
            <Container>
                <LoadingSpinner />
            </Container>
        )
    }

    if (loadError) {
        return (
            <Container>
                <ContainerDivs>
                    <DataSelected>
                        <SlActionUndo fontSize={'30px'} onClick={Return} />
                    </DataSelected>
                    <ErrorMessage>{loadError}</ErrorMessage>
                    <Btt02 onClick={() => setReloadKey(k => k + 1)}>Tentar novamente</Btt02>
                </ContainerDivs>
            </Container>
        )
    }

    return (
        <Container>
            <ContainerDivs>
                <h2>Grade Final</h2>

                {open === 'aberto' ? (
                    <>
                        {id_matter && (
                            <AreaWrapper>
                                <Area>
                                    <h3>Selecionar Outra Disciplina</h3>
                                    <Select
                                        id="id-matter"
                                        value={selectedMatter}
                                        onChange={(e) => setSelectedMatter(e.target.value)}
                                    >
                                        <option value="">Selecione a disciplina</option>
                                        {matter.map(res => (
                                            <option key={res._id} value={res._id}>{res.name}</option>
                                        ))}
                                    </Select>
                                    <Btt02 onClick={handleDefineMatter} disabled={definingMatter}>
                                        {definingMatter ? 'Definindo...' : 'Definir'}
                                    </Btt02>
                                </Area>
                            </AreaWrapper>
                        )}

                        <ContainerStudent>
                            {id_matter && (
                                <DataSelected>
                                    <SlActionUndo fontSize={'30px'} onClick={Return} />
                                    <Info>
                                        <p>Grade Final</p>
                                        <p>Disciplina: {Namematter}</p>
                                    </Info>
                                    <LegendBox>
                                        <h3>Legenda</h3>
                                        <p><strong style={{ color: '#1d7f14' }}>A</strong> - Alcançou com êxito as capacidades básicas</p>
                                        <p><strong style={{ color: 'blue' }}>B</strong> - Alcançou satisfatoriamente as capacidades básicas</p>
                                        <p><strong style={{ color: 'orange' }}>C</strong> - Alcançou parcialmente as capacidades básicas</p>
                                        <p><strong style={{ color: 'red' }}>D</strong> - Não alcançou as capacidades básicas</p>
                                    </LegendBox>
                                </DataSelected>
                            )}

                            {warning && <ErrorMessage>{warning}</ErrorMessage>}
                            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}

                            {stdt.length > 0 && !update_id_grade && (
                                <List>
                                    {[...stdt]
                                        .sort((a, b) => a.name.localeCompare(b.name))
                                        .map(student => (
                                            <Emp key={student._id}>
                                                <Span>{student.name}</Span>
                                                <ContConcept>
                                                    {renderBimTable(student._id)}
                                                    <Grade>
                                                        <ContSelect>
                                                            <p>Conceito:</p>
                                                            <Select
                                                                value={student.concept}
                                                                onChange={(e) => handleConceptChange(student._id, e.target.value)}
                                                                disabled={student.concept === '-'}
                                                            >
                                                                <option value="">Selecione</option>
                                                                <option value="A">A</option>
                                                                <option value="B">B</option>
                                                                <option value="C">C</option>
                                                                <option value="D">D</option>
                                                            </Select>
                                                        </ContSelect>
                                                        <label style={{ marginTop: '6px', display: 'flex', alignItems: 'center' }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={student.concept === '-'}
                                                                onChange={(e) =>
                                                                    handleConceptChange(student._id, e.target.checked ? '-' : '')
                                                                }
                                                            />
                                                            <span style={{ marginLeft: '6px' }}>
                                                                Não adicionar nota para este aluno
                                                            </span>
                                                        </label>
                                                    </Grade>
                                                </ContConcept>
                                            </Emp>
                                        ))}

                                    <Btt01 onClick={handleFinalize} disabled={finalizing}>
                                        {finalizing ? 'Enviando...' : 'Finalizar'}
                                    </Btt01>
                                </List>
                            )}

                            {checked.length > 0 && !update_id_grade && (
                                <ListChecked>
                                    {[...checked]
                                        .sort((a, b) => a.id_student.name.localeCompare(b.id_student.name))
                                        .map(item => (
                                            <Emp key={item._id}>
                                                <Span>{item.id_student.name}</Span>
                                                {renderBimTable(item.id_student._id, item.studentGrade)}
                                                <Btt02
                                                    onClick={() => startEditing(item)}
                                                    disabled={String(item._id).startsWith('temp-')}
                                                >Editar</Btt02>
                                                <Btt02
                                                    onClick={() => handleDeleteClick(item)}
                                                    disabled={String(item._id).startsWith('temp-')}
                                                >Deletar</Btt02>
                                            </Emp>
                                        ))}

                                    {confirmModal && (
                                        <BlurBackground>
                                            <ModalContainer>
                                                <h3>
                                                    Tem certeza que deseja deletar o conceito de{' '}
                                                    <strong>{selectedGrade?.id_student?.name}</strong>?
                                                </h3>
                                                <div>
                                                    <button
                                                        style={{ backgroundColor: 'red', color: 'white' }}
                                                        onClick={handleConfirm}
                                                        disabled={deleting}
                                                    >
                                                        {deleting ? 'Deletando...' : 'Sim'}
                                                    </button>
                                                    <button onClick={handleCancel} disabled={deleting}>Não</button>
                                                </div>
                                            </ModalContainer>
                                        </BlurBackground>
                                    )}
                                </ListChecked>
                            )}

                            {update_id_grade && namestudent && (
                                <EditContainer>
                                    <h3>Editando Nota</h3>
                                    <EmpEdit>
                                        <Span>{namestudent?.id_student?.name}</Span>
                                        <Grade>
                                            <p>Conceito: </p>
                                            <Select
                                                value={update_studentGrade}
                                                onChange={(e) => setUpdateStudentGrade(e.target.value)}
                                                disabled={update_studentGrade === '-'}
                                            >
                                                <option value="">Selecione</option>
                                                <option value="A">A</option>
                                                <option value="B">B</option>
                                                <option value="C">C</option>
                                                <option value="D">D</option>
                                            </Select>
                                            <label style={{ marginTop: '6px', display: 'flex', alignItems: 'center' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={update_studentGrade === '-'}
                                                    onChange={(e) => setUpdateStudentGrade(e.target.checked ? '-' : '')}
                                                />
                                                <span style={{ marginLeft: '6px' }}>
                                                    Não adicionar nota para este aluno
                                                </span>
                                            </label>
                                        </Grade>
                                    </EmpEdit>
                                    <BoxButton>
                                        <Btt02 onClick={saveEdit} disabled={savingEdit}>
                                            {savingEdit ? 'Salvando...' : 'Salvar'}
                                        </Btt02>
                                        <Btt02 onClick={cancelEditing} disabled={savingEdit}>Cancelar</Btt02>
                                    </BoxButton>
                                </EditContainer>
                            )}
                        </ContainerStudent>
                    </>
                ) : (
                    <p>O ultimo periodo esta fechado, para editar contate o Diretor ou Supervisor.</p>
                )}

                {showMatterUpdated && (
                    <div style={{
                        position: 'fixed',
                        top: '120px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        background: '#4caf50',
                        color: '#fff',
                        padding: '12px 20px',
                        borderRadius: '8px',
                        zIndex: 9999,
                        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                        fontWeight: 'bold'
                    }}>
                        A disciplina foi alterada com sucesso.
                    </div>
                )}
            </ContainerDivs>

            {/* Sem matéria selecionada: escolher disciplina */}
            {!id_matter && (
                <ContainerDivs>
                    <h2>Selecione a Disciplina</h2>
                    <InputArea>
                        <Input>
                            <Label>Disciplina</Label>
                            <Select
                                id="id-matter"
                                value={selectedMatter}
                                onChange={(e) => setSelectedMatter(e.target.value)}
                            >
                                <option value="">Selecione</option>
                                {matter.map(res => (
                                    <option key={res._id} value={res._id}>{res.name}</option>
                                ))}
                            </Select>
                        </Input>
                        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                        <Btt02 onClick={handleDefineMatter} disabled={definingMatter}>
                            {definingMatter ? 'Definindo...' : 'Definir'}
                        </Btt02>
                        <ToGoBack onClick={Finalyze}>
                            <SignMessageButtonText>Voltar para a</SignMessageButtonText>
                            <SignMessageButtonTextBold>Turma</SignMessageButtonTextBold>
                        </ToGoBack>
                    </InputArea>
                </ContainerDivs>
            )}
        </Container>
    )
}

export default Finalconcepts
